import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function createCovep(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/covep`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result.data;
}

export async function getCoveps(accessToken, dateFrom, dateTo) {
  const result = await axios.get(
    `${BASE_API_URL}/chart/${dateFrom}/${dateTo}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return result.data;
}
